<template>
  <div style="height: 100%">
    <ViewItem class="myViewItem" label="授权系统">
      <Select transfer placeholder="请选择授权系统" v-model="currentAppId" disabled @on-change="appSelectChange" >
        <Option v-for="(item, index) in treeDataObj.app" :key="index" :label="item.title" :value="item.id"></Option>
      </Select>
    </ViewItem>
    <div class="permissionMain">
      <SetPermission
        class="serPermissions"
        v-for="(item, index) in listData"
        :ref="item.type"
        :key="index"
        :treeData="treeDataObj[item.type]"
        :title="item.title"
        :isSelect="item.isSelect"
        :hasSearch="item.hasSearch"
        :hasSubmit="item.hasSubmit"
        :selectAll="item.selectAll"
        :type="item.type"
        @on-select-change="onSelectChange"
        @on-check-change="onCheckChange"
        @on-select-submit="onSelectSubmit"
        @on-search-change="onSearchChange"
        @on-select-all='onSelectAll'
      />
    </div>
    <SelectDepartment v-if="selectDepartmentVisible" :type="currentDepartmentType" :visible.sync="selectDepartmentVisible" :selectList="departmentSelectList" @on-submit="selectDepartmentSubmit" :originData="departmentUseOriginData" />
  </div>
</template>
<script>
import _ from 'lodash';
import { mapActions } from 'vuex';
import util from '@/assets/js/util';
import SetPermission from '@/components/custom-setPermission';
import { getConfigByType } from './componentsConfig';
import { getRoleAppRowRuleApi, submitRoleAppRowRuleApi } from '@/api/roleManage';
import SelectDepartment from './SelectDepartment.vue';

const customDepartmentID = 'custom_department';
export default {
  components: { SetPermission, SelectDepartment },
  props: {
    roleId: {
      type: String,
      default: ''
    },
    currentAppId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentMenuId: '',
      listData: [
        // {
        //   title: '授权系统',
        //   type: 'app',
        //   itemName: ''
        // },
        {
          title: '系统行数据权限',
          type: 'systemRow',
          hasSubmit: true,
          isSelect: true,
          selectAll: true
        },
        {
          title: '菜单权限',
          type: 'menu',
          hasSubmit: true,
          isSelect: true,
          hasSearch: true
        },
        {
          title: '页面控件权限',
          type: 'component',
          isSelect: true,
          hasSubmit: true,
          selectAll: true
        },
        {
          title: '页面列数据权限',
          type: 'col',
          isSelect: true,
          hasSubmit: true,
          selectAll: true
        },
        {
          title: '页面行数据权限',
          type: 'row',
          isSelect: true,
          hasSubmit: true,
          selectAll: true
        }
        // {
        //   title: '自定义部门',
        //   type: 'department',
        //   isSelect: true,
        //   hasSubmit: false,
        //   selectAll: true,
        //   hasSearch: true
        // }
      ],
      treeDataObj: {
        app: [],
        systemRow: [],
        menu: [],
        component: [],
        col: [],
        row: []
      },
      changeSelectIdsMap: {
        app: [],
        systemRow: [],
        menu: [],
        component: [],
        col: [],
        row: []
      },
      searchUseData: {
        menu: []
      },
      // 保存原始数据
      originData: {
        systemRow: [],
        row: []
      },
      menuSelectIds: [],
      currentDepartSelectIds: [], // 当前选择的部门id
      selectDepartmentVisible: false, // 选择部门弹框展示隐藏
      departmentSelectList: [], // 部门选择列表
      currentDepartmentType: '' // 部门弹框所需类型 row，systemRow
    };
  },
  computed: {
    departmentUseOriginData () {
      return (this.originData[this.currentDepartmentType] || []).find(i => i.id === customDepartmentID) || {};
    }
  },
  methods: {
    ...mapActions('characterManage', ['getDepartmentInfo']),
    // 全选/全不选
    onSelectAll({ type, checkAll }) {
      const list = this.treeDataObj[type];
      let newList = [];
      newList = list.map((item, index) => {
        if (item.id != customDepartmentID) {
          item.checked = checkAll;
        }
        // if (checkAll && index == 0) {
        //   item.selected = true;
        // } else {
        //   item.selected = false;
        // }
        return item;
      });
      this.changeSelectIdsMap = {
        ...this.changeSelectIdsMap,
        [type]: [...newList]
      };
      // 将对应的数据给菜单数据选中
      const currentMenu = util.getCurrentData(
        this.treeDataObj.menu,
        this.currentMenuId
      );
      if (!currentMenu.checked) {
        currentMenu.checked = true;
        this.setParentSelect({
          type: 'menu',
          changeItem: currentMenu,
          isDelete: false
        });
      }
    },
    // 获取系统信息
    getAppInfo() {
      // 获取app列表
      this.$ajax.post('/v1/orgUserAuth/ownAppInAuthUserList').then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          const appAuthorization = data.map(item => ({
            id: item.id,
            title: item.name,
            needSelected: true
          }));
          this.treeDataObj = { ...this.treeDataObj, app: appAuthorization };
          this.appSelectChange(this.currentAppId);
        }
      });
    },
    // 获取 菜单信息
    getMenuInfo(appId, type, clearType) {
      const data = {
        appId,
        roleId: this.roleId
      };
      const nextType = type[0];
      clearType.forEach(item => {
        // 清空所有的数据
        this.treeDataObj = {
          ...this.treeDataObj,
          [item]: []
        };
        // 清除更改过的数据
        this.changeSelectIdsMap = {
          ...this.changeSelectIdsMap,
          [item]: []
        };
      });
      this.$ajax.post('/v1/role/roleFuncMenu', data, { noUseGlobalLoading: true }).then(res => {
        const { data, code } = res.data;
        const menuSelectIds = [];
        if (code == 200) {
          const originMenuTreeData = data.map(item => {
            const {
              funcMenuId,
              parentMenuId,
              menuName,
              authStatus,
              ...rest
            } = item;
            if (authStatus) {
              menuSelectIds.push(funcMenuId);
            }
            return {
              ...rest,
              title: menuName,
              id: funcMenuId,
              pid: !parentMenuId || parentMenuId == '0' ? null : parentMenuId,
              needSelected: true,
              checked: !!authStatus
            };
          });
          const menuTreeData = util.getMenuTree(originMenuTreeData);
          this.treeDataObj = {
            ...this.treeDataObj,
            [nextType]: menuTreeData
          };
          this.searchUseData = {
            ...this.searchUseData,
            menu: _.cloneDeep(menuTreeData)
          };
          this.menuSelectIds = [...new Set(menuSelectIds)];
        }
      });
    },
    // 获取列，行，组件权限
    getOtherPermission(id, type, clearType) {
      clearType.forEach(item => {
        // 清空所有的数据
        this.treeDataObj = {
          ...this.treeDataObj,
          [item]: []
        };
        // 清除更改过的数据
        this.changeSelectIdsMap = {
          ...this.changeSelectIdsMap,
          [item]: []
        };
        this.currentDepartSelectIds = [];
      });
      Promise.all([
        this.getColData(id),
        this.getRowData(id),
        this.getComponentData(id)
      ]).then(([res1, res2, res3]) => {
        const colData = res1.map(item1 => {
          const { authStatus, ruleName, ...rest } = item1;
          return {
            ...rest,
            checked: !!authStatus,
            title: ruleName
          };
        });
        const rowData = res2.map(item2 => {
          const { authStatus, ruleName, ...rest } = item2;
          return {
            ...rest,
            checked: !!authStatus,
            title: ruleName,
            selDepartRelList: JSON.parse(item2.selDepartRelList || '[]'),
            allDepartRelList: JSON.parse(item2.selDepartRelList || '[]'),
            render: (h, { data }) => {
              return h('span', { style: { color: item2.id.indexOf('dar_') >= 0 ? 'red' : '' } }, data.title);
            }
          };
        });
        this.originData.row = JSON.parse(JSON.stringify(rowData));
        const componentData = res3.map(item3 => {
          const { authStatus, componentName, ...rest } = item3;
          return {
            ...rest,
            checked: !!authStatus,
            title: componentName
          };
        });
        this.treeDataObj = {
          ...this.treeDataObj,
          component: componentData,
          row: rowData,
          col: colData
        };
      });
    },
    // 获取列权限
    getColData(menuId) {
      const data = {
        roleId: this.roleId,
        funMenuId: menuId
      };
      return new Promise(resolve => {
        this.$ajax.post('/v1/role/roleDataColRule', data, { noUseGlobalLoading: true }).then(res => {
          const { code, data } = res.data;
          if (code == 200) {
            resolve(data);
          }
        });
      });
    },
    // 获取行权限
    getRowData(menuId) {
      const data = {
        roleId: this.roleId,
        funMenuId: menuId
      };
      return new Promise(resolve => {
        this.$ajax.post('/v1/role/roleDataRowRule', data, { noUseGlobalLoading: true }).then(res => {
          const { code, data } = res.data;
          if (code == 200) {
            if (Array.isArray(data)) {
              data.forEach(item => {
                item.needSelected = true;
                item.selected = false;
                if (item.id == customDepartmentID) {
                  const list = item.selDepartRelList ? JSON.parse(item.selDepartRelList || '[]') : [];
                  this.departmentSelectIds = list.map(dptId => parseInt(dptId));
                  this.currentDepartSelectIds = [...this.departmentSelectIds];
                  // 自定义部门不允许勾选
                  item.disableCheckbox = true;
                }
              });
            }
            resolve(data);
          }
        });
      });
    },
    // 获取组件权限
    getComponentData(menuId) {
      const data = {
        roleId: this.roleId,
        funMenuId: menuId
      };
      return new Promise(resolve => {
        this.$ajax.post('/v1/role/rolePageComponent', data, { noUseGlobalLoading: true }).then(res => {
          const { code, data } = res.data;
          if (code == 200) {
            resolve(data);
          }
        });
      });
    },
    // 保存菜单
    submitMenu(type) {
      return new Promise(resolve => {
        const data = this.changeSelectIdsMap[type];
        if (data.length == 0) {
          return this.$Message.error('未变化任何数据');
        }
        const funcMenuAuths = data.map(item => ({
          id: item.id,
          authStatus: item.checked ? 1 : 0
        }));
        this.$ajax
          .post('/v1/role/editFuncMenu', {
            funcMenuAuths,
            roleId: this.roleId,
            appId: this.currentAppId
          })
          .then(res => {
            const { code } = res.data;
            if (code == 200) {
              this.changeSelectIdsMap = {
                ...this.changeSelectIdsMap,
                [type]: []
              };
              resolve(true);
            }
          });
      });
    },
    // 控件、行列权限ajax 请求
    ajaxOthers(type) {
      return new Promise(resolve => {
        const data = this.changeSelectIdsMap[type];
        const { submitKey, submitUrl } = getConfigByType[type];
        // const checkedIdList = this.currentDepartSelectIds;
        // const unCheckedIdList = this.departmentSelectIds.filter(rId => !checkedIdList.includes(rId));

        let auths = [];
        if (type == 'row') {
          const appRowAuths = this.treeDataObj.row.map(i => {
            return {
              authStatus: i.checked ? 1 : 0,
              delSelDepartRelList: i.delSelDepartRelList,
              selDepartRelList: i.selDepartRelList,
              id: i.id
            };
          });
          auths = [...appRowAuths];
        } else {
          auths = data.map(item => ({
            id: item.id,
            authStatus: item.checked ? 1 : 0
          }));
        }
        // 提交之前，需要判断一下菜单是否有未提交的，如果有，就提交一下，之后再提交
        this.$ajax
          .post(submitUrl, {
            [submitKey]: auths,
            funcMenuId: this.currentMenuId,
            roleId: this.roleId
          })
          .then(res => {
            const { code } = res.data;
            if (code == 200) {
              // 保存部门保存后的数据，当前只有部门有数据，所以没做判断
              this.changeSelectIdsMap = {
                ...this.changeSelectIdsMap,
                [type]: []
              };
              if (type == 'row') {
                this.originData.row = JSON.parse(JSON.stringify(this.treeDataObj.row));
              }
              resolve();
            }
          });
      });
    },
    // 保存控件、行、列权限
    submitOthers(type) {
      const data = this.changeSelectIdsMap[type];
      // 如果是行权限保存，变化了部门也是变化
      if (type == 'row') {
        if (this.changeSelectIdsMap[type].length == 0 && !this.rowIsChange(this.originData.row, this.treeDataObj.row)) {
          return this.$Message.error('未变化任何数据');
        }
      } else {
        if (data.length == 0) {
          return this.$Message.error('未变化任何数据');
        }
      }
      const menuChangeSelect = this.changeSelectIdsMap.menu;
      if (menuChangeSelect.length > 0) {
        this.submitMenu('menu').then(res => {
          if (!res) return false;
          this.ajaxOthers(type);
        });
      } else {
        this.ajaxOthers(type);
      }
    },
    // 点击节点改变
    onSelectChange({ type, selectItem }) {
      const { id } = selectItem;
      if (type === 'app') {
        this.currentAppId = id;
      }
      if (type === 'menu') {
        this.menuTreeChange(selectItem);
        return;
      }
      // 系统行数据权限
      if (['systemRow', 'row'].includes(type)) {
        this.currentDepartmentType = type;
        this.selectDepartmentVisible = selectItem.id === customDepartmentID;
        this.departmentSelectList = selectItem.allDepartRelList ? selectItem.allDepartRelList : [];
        selectItem.selected = false;
        return;
      }
      const { getNextItem: method, nextType, clearType } = getConfigByType[
        type
      ] || {};
      if (type !== 'row') {
        this[method](id, nextType, clearType);
      }
    },
    // 设置父节点选中状态
    setParentSelect({ type, changeItem, isDelete }) {
      /*
        首先先把父节点的checked 置为 true，如果有父节点的话，在递归次函数，把父节点的 checked 改为 true
        这里面是一层一层往上找节点
       */
      // 先吧当前节点的checked 改为 true
      // 再把父节点递归
      const tree = this.treeDataObj[type];
      let changeData = [...this.changeSelectIdsMap[type]];

      this.menuSelectIds = [...this.menuSelectIds, changeItem.id];
      const ids = changeData.map(item => item.id);
      const flat = util.treeChangeFlat(tree).map(item => {
        const { parentNode, children, ...rest } = item;
        return {
          ...rest
        };
      });
      flat.forEach(item => {
        if (item.id == changeItem.id) {
          item.checked = true;
          if (ids.includes(item.id)) {
            changeData = changeData.filter(i => i.id != item.id);
          } else {
            changeData.push(item);
          }
        }
      });
      const data = util.getMenuTree(flat);
      this.treeDataObj = { ...this.treeDataObj, [type]: data };
      this.changeSelectIdsMap = {
        ...this.changeSelectIdsMap,
        [type]: changeData
      };
      if (changeItem.parentNode && !changeItem.parentNode.checked) {
        this.setParentSelect({
          type,
          changeItem: changeItem.parentNode,
          isDelete: true
        });
      }
    },
    // setParentStatus({ type, changeItem, isDelete, idListName, idName }) {
    //   const { children } = changeItem;
    //   if (children && children.length) {
    //     if (children.every(item => !item.checked)) {
    //       changeItem.checked = false;
    //       this[idListName] = [...this[idListName].filter(i => i !== changeItem[idName])];
    //     } else {
    //       changeItem.checked = true;
    //       this[idListName] = [...this[idListName], changeItem[idName]];
    //     }
    //   }
    //   if (changeItem.pid && changeItem.parentNode) {
    //     this.setParentStatus({ changeItem: changeItem.parentNode, isDelete, idName, idListName });
    //   }
    // },
    deleteChildrenNode({ type, children, isDelete }) {
      children.forEach(item => {
        let changeData = [...this.changeSelectIdsMap[type]];
        const ids = changeData.map(item => item.id);
        if (item.checked) {
          if (item.id == this.currentMenuId) {
            // 此时把控件、行、列权限里面的数据给清空选择
            this.clearComRowColChecked();
          }
          // 此时把选择关闭
          item.checked = false;
          if (ids.includes(item.id)) {
            // 此时存在，就删除data里面对应的数据
            changeData = changeData.filter(i => i.id != item.id);
          } else {
            // 此时加上对应的数据
            changeData.push(item);
          }
        }

        const menuSelectIds = this.menuSelectIds.filter(id => id != item.id);
        this.menuSelectIds = menuSelectIds;
        this.changeSelectIdsMap = {
          ...this.changeSelectIdsMap,
          [type]: changeData
        };
        if (item.children && item.children.length > 0) {
          this.deleteChildrenNode({
            type,
            children: item.children,
            isDelete: true
          });
        }
      });
    },
    // changeChildrenNode({ type, children, isDelete, idListName, idName }) {
    //   children.forEach(item => {
    //     if (item.checked) {
    //       if (item.id == this.currentMenuId) {
    //         // 此时把控件、行、列权限里面的数据给清空选择
    //         this.clearComRowColChecked();
    //       }
    //     }
    //     if (isDelete) {
    //       this[idListName] = [...this[idListName].filter(i => i !== item[idName])];
    //     } else {
    //       this[idListName] = [...this[idListName], item[idName]];
    //     }
    //     item.checked = !isDelete;
    //     if (item.children && item.children.length > 0) {
    //       this.changeChildrenNode({
    //         type,
    //         children: item.children,
    //         isDelete,
    //         idListName,
    //         idName
    //       });
    //     }
    //   });
    // },
    // 选择框选中不选中出发
    onCheckChange({ type, changeItem, isDelete }) {
      if (type !== 'department') {
        // 不是部门的选中修改，保留原始逻辑
        let changeData = [...this.changeSelectIdsMap[type]];
        const ids = changeData.map(item => item.id);
        // 如果是有值的话，说明，已经更改过对应的数据，所以，把之前的数据给干掉就可以了
        // 如果ids 里面没有现在选择过的值的话，就push进去，证明这个要搞一下
        if (ids.includes(changeItem.id)) {
        // 此时存在，就删除data里面对应的数据
          changeData = changeData.filter(item => item.id != changeItem.id);
        } else {
        // 此时加上对应的数据
          changeData.push(changeItem);
        }
        if (isDelete) {
          const menuSelectIds = this.menuSelectIds.filter(
            id => id != changeItem.id
          );
          this.menuSelectIds = menuSelectIds;
        } else {
          this.menuSelectIds = [...this.menuSelectIds, changeItem.id];
        }
        // 给变更过的ids赋值
        this.changeSelectIdsMap = {
          ...this.changeSelectIdsMap,
          [type]: changeData
        };
        // 如果有pid 的话，就判断是否是选中状态
        if (changeItem.pid && changeItem.parentNode && !isDelete) {
        // 此时有pid 并且是选中状态 就把父的选中
          if (!changeItem.parentNode.checked) {
          // 在此处把父节点的给选中
            this.setParentSelect({
              type,
              changeItem: changeItem.parentNode,
              isDelete: false
            });
          }
        }
        // 如果是有子节点的话，并且选择删除的时候，把子节点的给取消掉
        if (isDelete && changeItem.children && changeItem.children.length > 0) {
          this.deleteChildrenNode({
            type,
            children: changeItem.children,
            isDelete: true
          });
        }
        if (isDelete && changeItem.id == this.currentMenuId) {
        // 此时把控件、行、列权限里面的数据给清空选择
          this.clearComRowColChecked();
        }
        if (isDelete && changeItem.id == customDepartmentID) {
          // 清空部门选择
          this.clearDepartmentSelected();
        }
      }
      // 如果是数据非菜单权限的话，就在此调用一下这个方法
      if (!['menu', 'app'].includes(type) && changeItem.checked) {
        // 将对应的数据给菜单数据选中
        const currentMenu = util.getCurrentData(
          this.treeDataObj.menu,
          this.currentMenuId
        );
        if (!currentMenu.checked) {
          currentMenu.checked = true;
          this.setParentSelect({
            type: 'menu',
            changeItem: currentMenu,
            isDelete: false
          });
        }
      }
    },
    // 把行权限的设置为选中
    changeRowDataToSelected(needSelectedId) {
      // 如果是部门的选中,把行的部门选中
      const rowTree = this.treeDataObj['row'];
      const newList = rowTree.map(item => {
        return {
          ...item,
          checked: item.id == needSelectedId ? true : item.checked
        };
      });
      this.treeDataObj['row'] = newList;
    },
    // 清空部门选中
    clearDepartmentSelected() {
      const DataMap = this.treeDataObj['department'].map(i => ({
        ...i,
        checked: false
      }));
      this.treeDataObj = {
        ...this.treeDataObj,
        department: DataMap
      };
    },
    // 清空控件、行、列选中
    clearComRowColChecked() {
      const needClearArr = ['component', 'row', 'col'];
      needClearArr.forEach(key => {
        const DataMap = this.treeDataObj[key].map(i => ({
          ...i,
          checked: false
        }));
        this.treeDataObj = {
          ...this.treeDataObj,
          [key]: DataMap
        };
        this.changeSelectIdsMap = {
          ...this.changeSelectIdsMap,
          [key]: []
        };
        if (key === 'row') {
          this.originData.row = this.originData.row.map(i => ({ ...i, checked: false }));
        }
      });
    },
    // 保存按钮
    onSelectSubmit({ type }) {
      const { submitMethod: method } = getConfigByType[type];
      this[method](type);
    },
    onSearchChange({ value, type }) {
      const searchUseData = _.cloneDeep(this.searchUseData[type]);
      let searcheTree = [];
      const params = [...this.menuSelectIds];
      if (!value) {
        searcheTree = type == 'department' ? util.setSelectIdsByRelationId(searchUseData, params) : util.setSelectIds(searchUseData, params);
      } else {
        searcheTree = util.treeForSearch(
          searchUseData,
          value,
          params,
          type == 'department'
        );
      }
      this.treeDataObj = {
        ...this.treeDataObj,
        [type]: searcheTree
      };
    },
    // 系统选项下拉框的变化事件
    async appSelectChange (value) {
      if (this.currentAppId && this.currentAppId !== value) {
        await this.systemChange();
      }
      this.originData.row = [];
      const selectItem = this.treeDataObj.app.find(item => item.id === value);
      this.onSelectChange({ type: 'app', selectItem });
      // 获取系统行数据权限
      if (!value) {
        this.treeDataObj = { ...this.treeDataObj, systemRow: [], systemDepartment: [] };
        return;
      }
      this.getRoleAppRowRule({ appId: value, roleId: this.roleId });
    },
    getRoleAppRowRule (body) {
      getRoleAppRowRuleApi(body).then(res => {
        const { code, data } = res.data;
        if (code !== 200) return;
        const systemRow = data.map(i => {
          const selDepartRelList = JSON.parse(i.selDepartRelList || '[]');
          return {
            ...i,
            disableCheckbox: i.id === customDepartmentID,
            checked: !!i.authStatus,
            title: i.ruleName,
            needSelected: true,
            selDepartRelList: [...selDepartRelList || []],
            allDepartRelList: [...selDepartRelList || []]
          };
        });
        this.originData.systemRow = JSON.parse(JSON.stringify(systemRow));
        this.treeDataObj = { ...this.treeDataObj, systemRow: JSON.parse(JSON.stringify(systemRow)) };
      });
    },
    getAllDeptIds(list) {
      const newList = JSON.parse(JSON.stringify(list));
      function getIds (list) {
        const ids = [];
        for (let i = 0; i < list.length; i++) {
          ids.push(list[i].relationId);
          if (list[i].children && list[i].children.length > 0) {
            ids.push(...getIds(list[i].children));
          }
        }
        return ids;
      }
      return [...getIds(newList)];
    },
    // 部门确定问题
    selectDepartmentSubmit ({ selDepartRelList, type, delSelDepartRelList, allDepartRelList }) {
      const obj = this.treeDataObj[type].find(i => i.id === customDepartmentID) || {};
      let checked = true;
      if (selDepartRelList.length === 0) {
        checked = false;
      }
      if (type === 'row' && checked) {
        // 如果是页面行权限就设置对应的页面权限如果 false 的话 就设true
        // const changeItem = this.treeDataObj.menu.find(i => i.id === this.currentMenuId);
        // changeItem.checked = true;
        const refs = this.$refs.menu[0].getSelectedNodes();
        const changeItem = refs[0];
        if (!changeItem.checked) {
          changeItem.checked = true;
          this.onCheckChange({ type: 'menu', changeItem, isDelete: false });
        }
      }
      obj.checked = checked;
      obj.selDepartRelList = selDepartRelList || [];
      obj.delSelDepartRelList = delSelDepartRelList || [];
      obj.allDepartRelList = allDepartRelList || [];
    },
    // 保存全局行权限
    submitSystemRow (type, noFresh = false) {
      return new Promise(resolve => {
        if (!this.rowIsChange(this.originData.systemRow, this.treeDataObj.systemRow)) {
          return this.$Message.error('未变化任何数据');
        }
        const appRowAuths = this.treeDataObj.systemRow.map(i => {
          return {
            authStatus: i.checked ? 1 : 0,
            delSelDepartRelList: i.delSelDepartRelList,
            selDepartRelList: i.selDepartRelList,
            id: i.id
          };
        });
        submitRoleAppRowRuleApi({ appId: this.currentAppId, appRowAuths, roleId: this.roleId }).then(res => {
          resolve();
          console.log('noFresh', noFresh);
          // 刷新一下系统行数据权限列表
          !noFresh && this.getRoleAppRowRule({ appId: this.currentAppId, roleId: this.roleId });
        });
      });
    },
    // 判断行权限是否发生变化
    rowIsChange (originData, currentData) {
      /**
       * 判断行权限是否发生过变化
       * 1. 先判断外层的 是否发生过变化，如果发生过变化，那么直接返回true就行了
       * 2. 如果外层的没有发生过变化，那么就判断 自定义部门里的有没有发生过变化
       * 2.1 判断自定义部门里面的 selDepartRelList 里面的数据是否一样就行了
       * 3. 如果都没有发生过变化，那么直接返回false
       */
      const isDifferent = this.getDifferentData(originData, currentData);
      // 如果两层不一样，直接返回true。 证明更改过
      if (isDifferent) return true;
      // 如果两层一样，那么再继续判断自定义部门里面的

      const originDepartRelList = (originData.find(i => i.id === customDepartmentID) || {}).selDepartRelList || [];
      const currentDepartRelList = (currentData.find(i => i.id === customDepartmentID) || {}).selDepartRelList || [];
      if (originDepartRelList.length !== currentDepartRelList.length) return true;
      return !currentDepartRelList.every(item => originDepartRelList.includes(item));
    },
    // 判断两个对象是否一样
    getDifferentData (arr1, arr2) {
      const arr1StrArr = arr1.map(item => `${item.checked}_${item.id}`);
      const arr2StrArr = arr2.map(item => `${item.checked}_${item.id}`);
      return !arr1StrArr.every(item => arr2StrArr.includes(item));
    },
    // 系统切换时
    // 先判断页面控件是否保存，如果没有保存，那么进行询问是否需要保存
    // 判断页面行数据是否保存，如果没有保存，那么进行询问是否需要保存
    // 判断页面列数据是否保存，如果没有保存，那么进行询问是否需要保存
    // 判断页面权限数据是否保存，如果没有保存，那么进行询问是否需要保存
    systemChange () {
      return new Promise(resolve => {
        // 判断页面控件是否保存了
        const componentIsChange = this.componentIsChange();
        const colIsChange = this.colIsChange();
        const menuChange = this.menuChange();
        const rowIsChange = this.rowIsChange(this.originData.row, this.treeDataObj.row);
        const appRowIsChange = this.rowIsChange(this.originData.systemRow, this.treeDataObj.systemRow);
        if (componentIsChange || colIsChange || menuChange || rowIsChange || appRowIsChange) {
          this.$Modal.confirm({
            title: '提示',
            content: '是否保存当前系统权限配置变更',
            onOk: async () => {
              if (menuChange) {
                await this.submitMenu('menu');
              }
              if (componentIsChange) {
                await this.ajaxOthers('component');
              }
              if (colIsChange) {
                await this.ajaxOthers('col');
              }
              if (rowIsChange) {
                await this.ajaxOthers('row');
              }
              if (appRowIsChange) {
                await this.submitSystemRow('systemRow', true);
              }
              resolve(true);
            },
            onCancel: () => {
              resolve(true);
            }
          });
        } else {
          resolve(true);
        }
      });
    },
    componentIsChange () {
      const data = this.changeSelectIdsMap.component;
      return data.length > 0;
    },
    colIsChange () {
      const data = this.changeSelectIdsMap.col;
      return data.length > 0;
    },
    menuChange () {
      const data = this.changeSelectIdsMap.menu;
      return data.length > 0;
    },
    menuTreePromise () {
      return new Promise(resolve => {
        const colIsChange = this.colIsChange();
        const componentIsChange = this.componentIsChange();
        const rowIsChange = this.rowIsChange(this.originData.row, this.treeDataObj.row);
        const menuChange = this.menuChange();
        if (colIsChange || componentIsChange || rowIsChange || menuChange) {
          this.$Modal.confirm({
            title: '提示',
            content: '是否保存当前系统权限配置变更',
            onOk: async () => {
              if (menuChange) {
                await this.submitMenu('menu');
              }
              if (componentIsChange) {
                await this.ajaxOthers('component');
              }
              if (colIsChange) {
                await this.ajaxOthers('col');
              }
              if (rowIsChange) {
                await this.ajaxOthers('row');
              }
              resolve(true);
            },
            onCancel: () => {
              resolve(true);
            }
          });
        } else {
          resolve();
        }
      });
    },
    async menuTreeChange (selectItem) {
      if (this.currentMenuId) {
        await this.menuTreePromise();
      }
      const { id } = selectItem;
      this.currentMenuId = id;
      const { getNextItem: method, nextType, clearType } = getConfigByType.menu || {};
      this[method](id, nextType, clearType);
    }
  },
  created() {
    this.getAppInfo();
  }
};
</script>
<style lang="less" scoped>
.myViewItem {
  width: 30%;
}
.myViewItem /deep/ .view-item-label {
  font-size: 14px;
}
.permissionMain {
  display: flex;
  height: calc(~'100% - 56px');
  overflow-x: auto;
  background-color: #eee;
  .serPermissions {
    height: 100%;
    overflow-y: auto;
  }
}
</style>
